import React from 'react'
import { Alert } from 'antd'
import './VendedorFeedbackAlert.css' // Importando o CSS para estilização
const VendedorFeedbackAlert = ({ tipoFeedback }) => {
  if (!tipoFeedback) return null

  const map = {
    excelente: {
      message: `Você recebeu um feedback positivo ✨`,
      type: 'success'
    },
    bom: {
      message: `Você recebeu um feedback construtivo 💡`,
      type: 'info'
    },
    erro_corrigido: {
      message: `Você recebeu um feedback sobre um erro corrigido 🛠️`,
      type: 'warning'
    },
    falta_grave: {
      message: `Você recebeu um feedback negativo 📉`,
      type: 'error'
    }
  }

  const config = map[tipoFeedback]
  if (!config) return null

  return (
    <Alert
      className="vendedor-feedback-alert-custom"
      message={config.message}
      type={config.type}
      showIcon
    />
  )
}

export default VendedorFeedbackAlert
